import { Box } from '@mui/material';
import Image from 'next/image';
import React, { FC } from 'react';

interface NFTImageContainerProps {
  imageUrl: string;
  previewImgUrl?: string;
  onClick?: () => void;
}

const NFTImageContainer: FC<NFTImageContainerProps> = ({ imageUrl, previewImgUrl, onClick }) => {
  return (
    <Box>
      <Image
        alt="nft_image"
        fill
        loading="eager"
        src={imageUrl}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        style={{ borderRadius: '6px', objectFit: 'contain', height: '100%', width: '100%' }}
      />
      {previewImgUrl && (
        <Image
          src={previewImgUrl}
          alt="nft_preview"
          width={40}
          height={40}
          onClick={onClick}
          priority
          loading="eager"
          style={{
            position: 'absolute',
            bottom: '10px',
            objectFit: 'cover',
            right: '10px',
            borderRadius: '30%',
            cursor: 'pointer'
          }}
        />
      )}
    </Box>
  );
};

export default NFTImageContainer;
